module.exports = __webpack_public_path__ + "img/sg_71.565ab596.png";